import type { ILanguageResources, ITranslationModule } from '../../../../interfaces';
import { interpolate } from '../../../../global';

class Id {
  private constructor() {}

  public static readonly prefix =
    'UI.scripts.dealer-franchisee.purchase-orders.views.FranchiseePurchaseOrderSummaryTable.';
  public static readonly systemPurchaseOrderAbbrevNo = `${Id.prefix}systemPurchaseOrderAbbrevNo`;
  public static readonly franchiseePurchaseOrderAbbrevNo = `${Id.prefix}franchiseePurchaseOrderAbbrevNo`;
  public static readonly purchaseOrderTitle = `${Id.prefix}purchaseOrderTitle`;
  public static readonly projectTitle = `${Id.prefix}projectTitle`;
  public static readonly quoteTitle = `${Id.prefix}quoteTitle`;
  public static readonly author = `${Id.prefix}author`;
  public static readonly lastModified = `${Id.prefix}lastModified`;
  public static readonly status = `${Id.prefix}status`;
  public static readonly netCost = `${Id.prefix}netCost`;
}

export class LangFranchiseePurchaseOrderSummaryTable {
  private constructor() {}

  public static systemPurchaseOrderAbbrevNo(): string {
    return interpolate(Id.systemPurchaseOrderAbbrevNo);
  }

  public static franchiseePurchaseOrderAbbrevNo(): string {
    return interpolate(Id.franchiseePurchaseOrderAbbrevNo);
  }

  public static purchaseOrderTitle(): string {
    return interpolate(Id.purchaseOrderTitle);
  }

  public static projectTitle(): string {
    return interpolate(Id.projectTitle);
  }

  public static quoteTitle(): string {
    return interpolate(Id.quoteTitle);
  }

  public static author(): string {
    return interpolate(Id.author);
  }

  public static lastModified(): string {
    return interpolate(Id.lastModified);
  }

  public static status(): string {
    return interpolate(Id.status);
  }

  public static netCost(): string {
    return interpolate(Id.netCost);
  }
}

export class FranchiseePurchaseOrderSummaryTableModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.systemPurchaseOrderAbbrevNo,
      "System {{glossary 'purchase-order-abbrev'}} No.",
      'Column title for system purchase order number'
    );
    register.add(
      Id.franchiseePurchaseOrderAbbrevNo,
      "{{glossary 'franchisee'}} {{glossary 'purchase-order-abbrev'}} No.",
      'Column title for franchisee purchase order number'
    );
    register.add(Id.purchaseOrderTitle, "{{glossary 'purchase-order'}} Title", 'Column title for purchase order title');
    register.add(Id.projectTitle, "{{glossary 'project'}} Title", 'Column title for project title');
    register.add(Id.quoteTitle, "{{glossary 'quote'}} Title", 'Column title for quote title');
    register.add(Id.author, "{{glossary 'author'}}", 'Column title for author');
    register.add(Id.lastModified, 'Last Modified', 'Column title for last modified date');
    register.add(Id.status, 'Status', 'Column title for status');
    register.add(Id.netCost, 'Net Cost', 'Column title for net cost');
  }
}
